import '../../utils/Roboto-Regular-normal.js'

import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { generateEppFromInvoices } from '../../utils/invoices/createEPP_new.ts'
import {
  invoicesToPdfDoc,
  parseEppFile
} from '../../utils/invoices/eppSummaryPDF.ts'
import Breadcrumbs from '../common/Breadcrumbs/Breadcrumbs.tsx'

const EppReportPage: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { allInvoices, company, fromDate, toDate } = location.state || {}
  const [pdfUrl, setPdfUrl] = useState<string | null>(null)
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null)

  useEffect(() => {
    // Jeśli brak danych → wróć na poprzednią stronę:
    if (!allInvoices || !company || !fromDate || !toDate) {
      navigate('/payments/invoices', { replace: true })
      return
    }
    // Automatycznie generuj raport PDF
    const eppText = generateEppFromInvoices(
      allInvoices,
      company,
      fromDate,
      toDate
    )
    const faktury = parseEppFile(eppText)
    const doc = invoicesToPdfDoc(faktury, fromDate, toDate)
    const pdf = doc.output('blob')

    setPdfBlob(pdf)
    setPdfUrl(URL.createObjectURL(pdf))
  }, [allInvoices, company, fromDate, toDate, navigate])

  const handleDownload = () => {
    if (!pdfBlob) return
    const link = document.createElement('a')
    link.href = URL.createObjectURL(pdfBlob)
    link.download = `D24_Panel_Podsumowanie_${fromDate}_${toDate}.pdf`
    link.click()
  }

  if (!allInvoices || !company || !fromDate || !toDate) {
    return null
  }

  return (
    <>
      <Breadcrumbs
        pageName="Raport"
        breadcrumbs={[
          { label: 'Strona główna', path: '/' },
          { label: 'Faktury', path: '/payments/invoices' },
          { label: 'Raport' }
        ]}
      />

      <div className="mx-auto mt-8 bg-white dark:bg-gray-700 shadow p-6 rounded">
        <div className={'flex flex-row items-center justify-between'}>
          <div className={'flex flex-row items-center gap-2 text-2xl '}>
            <h1 className="font-bold">Podsumowanie</h1>
            <p className="">
              za okres: <strong>{fromDate}</strong> - <strong>{toDate}</strong>
            </p>
          </div>
          <div className="mb-4">
            <button
              onClick={handleDownload}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              Pobierz PDF
            </button>
          </div>
        </div>
        {pdfUrl ? (
          <iframe
            title="Podgląd PDF"
            src={pdfUrl}
            width="100%"
            height="900px"
            style={{ border: '1px solid #ddd', borderRadius: '8px' }}
          />
        ) : (
          <p>Generowanie raportu...</p>
        )}
      </div>
    </>
  )
}

export default EppReportPage
